import { useQuery } from "@tanstack/react-query";
import apiClient from "@/api/apiClient";
import { useAuth } from "./useAuth";

// Fetch all doctors for the current practice or specified practice
export const useDoctors = (practiceId = null, serviceId = null) => {
  const { user } = useAuth();

  // Use provided practiceId or fall back to current user's practice
  const targetPracticeId = practiceId || user?.practiceId;

  const isEnabled =
    !!serviceId || !!targetPracticeId || user?.userType !== "patient";

  const queryResult = useQuery({
    queryKey: ["doctors", targetPracticeId, serviceId],
    queryFn: async () => {
      let url;

      // If serviceId is provided, fetch doctors for that service
      if (serviceId) {
        url = `/api/users/doctors?serviceId=${serviceId}`;
        return await apiClient.get(url);
      }

      // For patients, pass practiceId as query param
      if (user?.userType === "patient" && targetPracticeId) {
        url = `/api/users/doctors?practiceId=${targetPracticeId}`;
        return await apiClient.get(url);
      }

      // For doctors/practice owners, use standard endpoint
      url = "/api/users/doctors";
      return await apiClient.get(url);
    },
    enabled: isEnabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return queryResult;
};

// Fetch doctor profile by ID
export const useDoctorProfile = (doctorId) => {
  return useQuery({
    queryKey: ["doctor", doctorId],
    queryFn: () => apiClient.get(`/api/doctors/${doctorId}`),
    enabled: !!doctorId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
